module.exports = __webpack_public_path__ + "static/media/exp_transitional_marker.d2b432ed.svg";